<template>
    <transition name="modal-fade">
        <div class="modal" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
                <div class="modal-content" style="width:1000px">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ $t('benefitSpecification') }}</h5>
                        <button type="button" class="btn-close" data-dismiss="modal" @click="close" aria-label="Close" />
                    </div>
                    <div class="modal-body">
                        <div v-if="tableDataLoaded" style="width: 100%">
                            <DataTable
                                :pageLength="5"
                                :lengthMenu="[ 5, 25, 50, 75, 100 ]"
                                :columns="tableColumns"
                                :data="tableData"
                                :options="tableOptions"
                                class="display"
                            />
                        </div>
                        <div v-else class="d-flex justify-content-center">
                            <div class="spinner-border" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                    </div> 
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="close" data-dismiss="modal" >
                            {{ $t('close') }} 
                        </button>
                    </div>
                </div>
            </div>
        </div>      
    </transition>
</template>

<script>
import DataTable from 'datatables.net-vue3';
import DataTablesLib from 'datatables.net';
import DatasetApi from '../../api/server/dataset';
import AssetTypeApi from '../../api/server/assetType';

DataTable.use(DataTablesLib);

export default {
    name: "benefitCalculationModal",
    mounted() {
        this.fetchData();
    },
    components: {
        DataTable
    },
    methods: {
        async fetchData() {
            var assetType = await AssetTypeApi.assetTypeDetail(this.$parent.$route.params.id, this.$parent.$route.params.assetTypeId);
            var datasetRecords = await DatasetApi.datasetSections(this.$parent.$route.params.id, assetType.datasetId);
           
            this.data = await DatasetApi.datasetDetail(this.$route.params.id, assetType.datasetId);
      
            if(this.data.content) {
                this.content = JSON.parse(this.data.content);
                this.tableColumns = [];
                if(this.content.headers) 
                    this.tableColumns = this.content.headers.map(h => ({ data: h.name, title: this.$t(h.alias), defaultContent: "", width: 100 }));
            }

            this.tableData = datasetRecords.map(s => s["properties"]);
            this.tableColumns.unshift({ data: "BENEFIT", title: this.$t("benefit"), defaultContent: "", width: 100 });
            
            var minMaxValues = {};
            for(var i in this.$parent.data.benefitAttributes) {
                var attribute = this.$parent.data.benefitAttributes[i];
                var attributeValues = [];

                for(var i in datasetRecords) {
                    var datasetRecord = datasetRecords[i];

                    var validProp = datasetRecord.properties[assetType.assetAttribute];

                    // If assetAttribute not number skip
                    if(!Number(validProp))
                        continue;

                    var datasetprop = datasetRecord.properties[attribute.name?.toUpperCase()];

                    attributeValues.push(datasetprop);

                }
                minMaxValues[attribute.name?.toUpperCase()] = {
                    minMaxValues: attributeValues,
                    biggerMoreBenefit: attribute.biggerMoreBenefit,
                    weight: attribute.weight
                }
            }
            for(var i in this.tableData) {
                var data = this.tableData[i];
                var validProp = data[assetType.assetAttribute];

                // If assetAttribute not number skip
                if(!Number(validProp))
                    continue;

                var result = this.valuateCalculationResult(minMaxValues, data);
                data["BENEFIT"] = result;
            }
         
            this.tableDataLoaded = true;
        },
        close() {
            this.$emit("closeDeleteDialog");
        },
        valuateCalculationResult(values, data) {
            var benefitSum = 0;
            var benefitKoefSum = 0;

            for(var i in values) {
                var attribute = values[i];
                
                var attrMinValue = Math.min(...attribute.minMaxValues);
                var attrMaxValue = Math.max(...attribute.minMaxValues);

                var scale = attrMaxValue - attrMinValue;
                if (scale > 0)
                {   
                    var value = data[i];

                    if (attribute.biggerMoreBenefit)
                    {
                        var k = (value - attrMinValue) / scale;
                        benefitSum += attribute.weight;
                        benefitKoefSum += k * attribute.weight;
                    }
                    else
                    {
                        var k = (attrMaxValue - value) / scale;

                        benefitSum += attribute.weight;
                        benefitKoefSum += k * attribute.weight;
                    }
                }
            }
            if (benefitSum > 0)
                return benefitKoefSum / benefitSum;
        }
    },
    data() {
        return {
            benefitAttributes: [],
            testingSection1: 0,
            testingSection2: 0,
            tableColumns: [],
            tableData: [],
            tableOptions: {
                fixedHeader: {
                    header: false,
                    footer: true
                },
                scrollX: true,
                scrollY: 350,
                order: [0, 'desc']
            },
            tableDataLoaded: false
        }
    }
};
</script>